var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "props-list"
  }, [_vm._l((_vm.fragment), function(_, prop) {
    return (_vm.$root.showURI || prop[0] !== '@') ? _c('prop', {
      key: prop,
      attrs: {
        "fragment": _vm.fragment,
        "prop": prop
      },
      on: {
        "focus": function($event) {
          _vm.listFocus(prop)
        }
      }
    }) : _vm._e()
  }), _vm._v(" "), _c('prop-add', {
    attrs: {
      "fragment": _vm.fragment
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "backdrop",
    class: _vm.backdropClasses,
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.listBlur($event)
      }
    }
  })], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16dd787f","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PropsList.vue
// module id = 77
// module chunks = 1